// extracted by mini-css-extract-plugin
module.exports = {"signInForm":"new-password_signInForm__2oIGT"};